import { useEffect } from 'react';

// These are the standard events that are used by Facebook
// they should be used with 'track' method
// https://developers.facebook.com/docs/meta-pixel/reference#standard-events
const StandardEvents = {
  PAGE_VIEW: 'PageView',
  SEARCH: 'Search',
  SUBSCRIBE: 'Subscribe',
};

// Custom events that are used by the app
const CustomEvents = {
  BANNER_CLICK: 'BannerClick',
};

export const EVENTS = {
  ...StandardEvents,
  ...CustomEvents,
};

export const TrackEvent = (event = EVENTS.PAGE_VIEW, data = {}) => {
  if (import.meta.env.DEV) return;

  if (event !== EVENTS.PAGE_VIEW && Object.keys(data).length === 0) {
    throw new Error('Data is required for non-page view events');
  }

  if (!Object.values(EVENTS).includes(event)) {
    throw new Error('Invalid event');
  }

  // if not an StandardEvent, then it should be a CustomEvent
  const eventType = Object.values(StandardEvents).includes(event)
    ? 'track'
    : 'trackCustom';

  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(eventType, event, data);
  }
};

export const useTrackPageView = () => {
  useEffect(() => {
    TrackEvent(EVENTS.PAGE_VIEW);
  }, []);
};
